import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { memo } from 'react';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../../constants/routing/NavItems';
import ProductIcon from './ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductPageTitle = ({
  productLine,
  nonProductIdentifier
}) => {
  var _tradeMarkMap$product, _tradeMarkMap$nonProd, _tradeMarkMap$product2, _tradeMarkMap$nonProd2;
  if (nonProductIdentifier === NavItemEnum.COMMERCE) {
    productLine = COMMERCE;
  }
  const tradeMarkMap = {
    [MARKETING]: {
      includeRegisteredTrademark: true
    },
    [SALES]: {
      includeRegisteredTrademark: true
    },
    [SERVICE]: {
      includeRegisteredTrademark: true
    },
    [CMS]: {
      includeTrademark: true
    },
    [OPERATIONS]: {
      includeRegisteredTrademark: true
    },
    [COMMERCE]: {
      includeTrademark: true
    },
    [NavItemEnum.SMART_CRM]: {
      includeTrademark: true
    }
  };
  const translationKeyMap = {
    [MARKETING]: 'pricingPage.pages.products.tabs.marketing.pageTitle',
    [SALES]: 'pricingPage.pages.products.tabs.sales.pageTitle',
    [SERVICE]: 'pricingPage.pages.products.tabs.service.pageTitle',
    [CMS]: 'pricingPage.pages.products.tabs.cms.pageTitle',
    [OPERATIONS]: 'pricingPage.pages.products.tabs.data.pageTitle',
    [COMMERCE]: 'pricingPage.pages.products.tabs.commerce.pageTitle',
    [NavItemEnum.SMART_CRM]: 'pricingPage.pages.products.tabs.smart-crm.pageTitle',
    [NavItemEnum.BUNDLE]: 'pricingPage.pages.products.tabs.bundle.pageTitle',
    [NavItemEnum.FREE]: 'pricingPage.pages.products.tabs.crm.pageTitle',
    [NavItemEnum.SUITE]: 'pricingPage.pages.products.tabs.suite.pageTitle',
    [NavItemEnum.MARKETING_PLUS]: 'pricingPage.pages.products.tabs.marketing-plus.pageTitle',
    [NavItemEnum.HUBSPOT_CREDITS]: 'pricingPage.pages.products.tabs.hubspot-credits.pageTitle'
  };
  const hasTrademark = productLine && ((_tradeMarkMap$product = tradeMarkMap[productLine]) === null || _tradeMarkMap$product === void 0 ? void 0 : _tradeMarkMap$product.includeTrademark) || nonProductIdentifier && ((_tradeMarkMap$nonProd = tradeMarkMap[nonProductIdentifier]) === null || _tradeMarkMap$nonProd === void 0 ? void 0 : _tradeMarkMap$nonProd.includeTrademark);
  const hasRegisteredTrademark = productLine && ((_tradeMarkMap$product2 = tradeMarkMap[productLine]) === null || _tradeMarkMap$product2 === void 0 ? void 0 : _tradeMarkMap$product2.includeRegisteredTrademark) || nonProductIdentifier && ((_tradeMarkMap$nonProd2 = tradeMarkMap[nonProductIdentifier]) === null || _tradeMarkMap$nonProd2 === void 0 ? void 0 : _tradeMarkMap$nonProd2.includeRegisteredTrademark);
  return /*#__PURE__*/_jsxs(PageTitle, {
    "aria-level": 1,
    children: [/*#__PURE__*/_jsx(ProductIcon
    // @ts-expect-error typescript@5.7.3 stricter type checking
    , {
      name: productLine || nonProductIdentifier,
      iconStyle: {
        marginInlineEnd: '300',
        blockSize: '32px',
        inlineSize: '32px'
      }
    }), productLine && translationKeyMap[productLine] && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[productLine]
    }), nonProductIdentifier && translationKeyMap[nonProductIdentifier] && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[nonProductIdentifier]
    }), hasTrademark && /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-400",
      children: "\u2122"
    }), hasRegisteredTrademark && /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-400",
      children: "\xAE"
    })]
  });
};
export default /*#__PURE__*/memo(ProductPageTitle);